import HeroSection from '../sections/ResidentParcelDashboardSection/HeroSection/HeroSection';

function Contact() {
  return (
    <div>
      <HeroSection title="Contact Us" subtitle="We'd love to hear from you!" />
      <p style={{ padding: "20px" }}>Email us at contact@example.com</p>
    </div>
  );
}

export default Contact;
